import styled from 'styled-components';
// import { Menu as MenuPlasma } from "@sms/plasma-ui";
import { Menu as MenuAntd } from 'antd';

export const Menu = styled(MenuAntd)`
  background-color: #f4f4f4;

  .ant-menu-submenu {
    margin: 0 !important;
    padding:  0 16px !important;
    position: unset;
    padding: 0 16px;

    &.ant-menu-submenu-active {
      border-bottom: 2px solid transparent !important;
      > .ant-menu-submenu-title {
        color: rgba(0, 0, 0, 0.85) !important;
      }
    }

    &.ant-menu-submenu-selected {
      background-color: #0775bc;
      > .ant-menu-submenu-title {
          color: #fff !important;
        }
      &, &:hover {
        color: #fff !important;
      }
      div[class^='Icon'] {
          svg {
            color: #fff !important;
          }
      }
    }
  }
  div[class^='Icon'] {
      svg {
        font-size: 16px;
        margin-right: 8px;
      }
  }
`;

